module.exports = __webpack_public_path__ + "static/img/list-fitLife.e016b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maskPng/list-fitLife.png
// module id = TTue
// module chunks = 1